'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faConciergeBell } from '@fortawesome/free-solid-svg-icons';

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-24 bg-unmulDarkGreen text-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold">
            LAYANAN <span className="text-unmulYellow">KAMI</span>
          </h2>
          <p className="text-green-100 mt-4 max-w-3xl mx-auto text-lg">
            Daftar layanan yang tersedia di unit kerja kami.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 text-center">
            {/* Placeholder Content */}
            {[1, 2, 3].map((i) => (
                <div key={i} className="bg-white/10 p-8 rounded-xl backdrop-blur-sm border border-white/20">
                    <div className="w-16 h-16 mx-auto bg-unmulYellow text-unmulDarkGreen rounded-full flex items-center justify-center text-2xl mb-6">
                        <FontAwesomeIcon icon={faConciergeBell} />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-3">Layanan {i}</h3>
                    <p className="text-green-100">Deskripsi singkat mengenai layanan ini dan bagaimana cara mengaksesnya.</p>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
}
